import { normalizeStickers } from '@components/previewUI/components/StickerLayer/index.js';
import { createSlice } from '@reduxjs/toolkit';

import { pagesStore, pagesUpdateList } from '../pages/pagesSlice.js';

// Per-page profile stickers (free-positioned decorative overlays). Seeded from the
// pages payload (each page carries a Stickers JSON string), edited live in the
// preview, and autosaved per page by stickersSaga (debounced).
const EMPTY = [];

export const stickersSlice = createSlice({
  name: 'stickers',
  initialState: {
    byPage: {}, // { [pageId]: Sticker[] }
    editMode: false, // interactive editing on the preview
  },
  reducers: {
    stickerAdd: (state, { payload: { pageId, sticker } }) => {
      if (!state.byPage[pageId]) state.byPage[pageId] = [];
      state.byPage[pageId].push(sticker);
    },
    stickerUpdate: (state, { payload: { pageId, id, patch } }) => {
      const sticker = state.byPage[pageId]?.find((s) => s.id === id);
      if (sticker) Object.assign(sticker, patch);
    },
    stickerRemove: (state, { payload: { pageId, id } }) => {
      if (state.byPage[pageId]) state.byPage[pageId] = state.byPage[pageId].filter((s) => s.id !== id);
    },
    stickersSetForPage: (state, { payload: { pageId, stickers } }) => {
      state.byPage[pageId] = stickers;
    },
    stickersSetEditMode: (state, { payload }) => {
      state.editMode = payload;
    },
  },
  extraReducers: (builder) => {
    // Seed per-page stickers whenever the pages list arrives/refreshes.
    const seed = (state, { payload }) => {
      const list = payload?.list || (Array.isArray(payload) ? payload : null);
      if (!list) return;
      list.forEach((page) => {
        if (page && page.id != null) state.byPage[page.id] = normalizeStickers(page.stickers);
      });
    };
    builder.addCase(pagesStore, seed).addCase(pagesUpdateList, seed);
  },
});

export const { stickerAdd, stickerUpdate, stickerRemove, stickersSetForPage, stickersSetEditMode } = stickersSlice.actions;

export const selectStickersEditMode = (state) => state.stickers.editMode;
export const selectStickersForPage = (pageId) => (state) => state.stickers.byPage[pageId] || EMPTY;

export default stickersSlice.reducer;
